import TaskComponent from "./TaskComponent";
import {useMyTasks} from "../../hooks/taskHooks";
import {Paginator} from "primereact/paginator";
import React, {useState} from "react";
import {useSelector} from "react-redux";

const TaskSwimLane = ({name, status, paginator, show}) => {
    const selectedYear = useSelector(state => state.kpi.selectedYear);
    const tasks = useMyTasks(status, show, selectedYear);
    const [first, setFirst] = useState(0);

    return (
        <div className={`swimlane swimlane-${name.toLowerCase()}`}>
            <div className="swimlane-title">{name}</div>
            <div className="swimlane-tasks">{((paginator && tasks.slice(first, first + 5)) || tasks).map(task => (<TaskComponent key={task.id} task={task} />))}</div>
            {paginator && tasks.length > 5 && <Paginator rows={5} totalRecords={tasks.length} first={first} onPageChange={(e) => setFirst(e.first)}></Paginator>}
        </div>
    )
}

export default TaskSwimLane;
